import React from "react"
import { useParams } from "react-router-dom"
import { BreadcrumbComponent } from "../../components/common/breadcrumb"
import { CompanyComponent } from "../../components/company"
import { DefaultPageComp } from "../../components/defaultPage"

export const CompanyPage = () => {
  const { id } = useParams()
  return <>
    <DefaultPageComp>
      <BreadcrumbComponent />
      <CompanyComponent id={Number(id)} />
    </DefaultPageComp>
  </>
}